/**
 * Die Zeiträume selbst: Tabelle ab genug Breite, darunter gestapelte Karten.
 *
 * Die Umschaltung hängt an einer Container-Query. Der Dialog ist bis 1152 px breit, aber auf
 * einem Telefon nur rund 328 px — zehn Spalten lagen dort hinter einem horizontalen Scroll, und
 * ausgerechnet die Beschränkungen und die Entfernen-Schaltfläche standen ganz rechts.
 */
import { Plus } from 'lucide-react';
import { MultiRangeCard } from './MultiRangeCard';
import { MultiRangeRow } from './MultiRangeRow';
import type { MultiRangeRow as Row } from './multiRangeRowModel';

const HEADERS = [
  'Beginn',
  'Ende',
  'Preis je Nacht',
  'Verfügbarkeit',
  'Mindestaufenthalt',
  'Höchstaufenthalt',
  'Keine Anreise',
  'Keine Abreise',
  'Verkaufsstopp',
  '',
];

interface Props {
  rows: Row[];
  disabled: boolean;
  onPatch: (id: string, patch: Partial<Row>) => void;
  onRemove: (id: string) => void;
  onAdd: () => void;
}

export function MultiRangeEditor({ rows, disabled, onPatch, onRemove, onAdd }: Props) {
  return (
    <div className="@container">
      <table className="@4xl:table hidden w-full text-xs">
        <thead className="text-ink-soft border-line/40 border-b text-left text-[10px] uppercase tracking-wider">
          <tr>
            {HEADERS.map((h, i) => (
              <th
                key={h || 'aktion'}
                className={i === HEADERS.length - 1 ? 'w-12 py-2' : 'py-2 pr-2 font-medium'}
              >
                {h || <span className="sr-only">Zeitraum entfernen</span>}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map((row, i) => (
            <MultiRangeRow
              key={row.id}
              row={row}
              index={i}
              onChange={(patch) => onPatch(row.id, patch)}
              onRemove={() => onRemove(row.id)}
              disabled={disabled}
            />
          ))}
        </tbody>
      </table>

      <ul className="@4xl:hidden grid gap-3">
        {rows.map((row, i) => (
          <MultiRangeCard
            key={row.id}
            row={row}
            index={i}
            onChange={(patch) => onPatch(row.id, patch)}
            onRemove={() => onRemove(row.id)}
            disabled={disabled}
          />
        ))}
      </ul>

      <button
        type="button"
        onClick={onAdd}
        disabled={disabled || rows.length >= 50}
        className="text-ink-soft hover:text-ink mt-3 inline-flex min-h-11 items-center gap-1.5 text-xs disabled:opacity-40"
      >
        <Plus size={12} aria-hidden />
        <span>Zeitraum hinzufügen</span>
        <span className="text-ink-faint">({rows.length} von 50)</span>
      </button>
    </div>
  );
}
